module.exports = __webpack_public_path__ + "static/media/record_voice_over.72236fcb.svg";